import React from "react";
import { getProgressColor } from "@icarius-utils/colors";
import { Typography } from "@material-ui/core";

const ProgressBar = ({ value, small }) => {

    if (typeof value !== "number" || isNaN(value)) return null;

    return (
        <div
            style={{
                height: small ? 20 : 30,
                width: "100%",
                position: "relative",
            }}
        >
            <div
                style={{
                    width: "100%",
                    position: "absolute",
                    zIndex: 3,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                }}
            >
                <Typography className="whiteText" style={{ fontSize: 12 }}>
                    {value}%
                </Typography>
            </div>
            <div
                style={{
                    zIndex: 2,
                    height: "100%",
                    width: `${value}%`,
                    position: "absolute",
                    borderRadius: 15,
                    backgroundColor: getProgressColor(value),
                }}
            />
            <div
                style={{
                    height: "100%",
                    width: "100%",
                    position: "absolute",
                    borderRadius: 15,
                    border: `1px solid ${getProgressColor(value)}`,
                }}
            />
        </div>
    );
}

export default ProgressBar;